<template>
  <b-row>
    <b-col cols="12" v-if="item.recipient">
      <p class="m-0"><b>{{$t('views.firm.form.recipient')}}: </b>{{item.recipient.name}} {{item.recipient.surname}} <span>
        <router-link v-if="item.recipient.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.recipient['@id'] }}">
          <i style="color: #28a745" class="fa fa-arrow-right"></i>
        </router-link>
        <router-link v-else :to="{name: 'FirmShow', params: { id: item.recipient['@id'] }}">
          <i style="color: #28a745" class="fa fa-arrow-right"></i>
        </router-link>
        </span>
      </p>
    </b-col>
    <b-col cols="12" v-if="senderTypeOptions.length > 0">
      <b-form-group>
        <label
          for="excmrelation_idSenderType"
          class="form-control-label">{{$t('views.excmnotificationmessage.form.senderType')}}:</label>
        <model-select :isDisabled="Boolean(idSenderType)" :options="senderTypeOptions" v-model="item.senderType"></model-select>
        <div
          v-if="isInvalid('idSenderType')"
          class="invalid-feedback">{{ violations.idSenderType }}</div>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group>
        <label>{{$t('views.exsbinvoices.form.sentDate')}}:</label>
        <VueCtkDateTimePicker no-header
                              :label="$t('views.exsbinvoices.form.sentDate')"
                              v-model="item.plannedSending"
                              format="YYYY-MM-DD HH:mm"
                              :onlyDate="false"
                              :right="true"
                              formatted="YYYY-MM-DD HH:mm"
        >
        </VueCtkDateTimePicker>
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <label>{{$t("global.messageType")}}:</label>
      <b-form-group>
        <b-form-radio-group buttons button-variant="outline-primary" id="monthlyInvoice" v-model="item.messageType" name="monthlyInvoice">
          <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.exsbvindicationevents.index.eventTypeOne')}}</b-form-radio>
          <b-form-radio button-variant="outline-primary" :value="2">{{$t('views.exsbvindicationevents.index.eventTypeTwo')}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <b-form-checkbox
        id="approvalStatus"
        name="approvalStatus"
        v-model="item.approvalStatus"
        value="1"
        unchecked-value="0"
        class="float-left mt-4"
      >
        <p class="mt-1">{{$t('buttons.approveMessage')}}</p>
      </b-form-checkbox>
    </b-col>
    <template v-if="item.messageType === 1">
      <b-col cols="12" v-if="documentTemplateOptions">
        <b-form-group>
          <label for="documentTemplate">{{ $t('views.excmnotificationmessage.form.documentTemplate') }}:</label>
          <model-select :options="documentTemplateOptions" v-model="documentTemplate" @input="onDocumentTemplateSelect($event)"></model-select>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group>
          <label for="custom_email_content">{{ $t('views.excmnotificationmessage.form.mailTitle') }}:</label>
          <input id="invoiceMailTitle" v-model="item.subject" :class="['form-control']" type="text" placeholder="" >
        </b-form-group>
      </b-col>
      <b-col cols="12" style="z-index: 0">
        <b-form-group>
          <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
          <trumbowyg ref="editor" v-model="item.contentEmail" :config="trumbowygConfig" class="form-control" name="htmlContent">
          </trumbowyg>
        </b-form-group>
      </b-col>
    </template>
    <b-col cols="12" v-else>
      <b-form-group>
        <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
        <input id="customSmsContent" v-model="item.content" :class="['form-control']" type="text" placeholder="">
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <button
        type="submit"
        class="btn btn-success"
        @click="handleSubmit()"
      >{{$t('buttons.submit')}}</button>
    </b-col>
  </b-row>
</template>

<script>
import ApiService from '@/utils/ApiService'
import { ModelSelect } from 'vue-search-select'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  components: { ModelSelect, Trumbowyg, VueCtkDateTimePicker },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },
    handleUpdateField: {
      type: Function,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    },
    idSenderType: {
      type: String,
      required: false,
      default: null
    },
    recipient: {
      required: false,
      default: null
    }
  },
  watch: {
  },
  mounted () {
  },
  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return this.errors || {}
    }
  },
  data () {
    return {
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdown
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          },
          insertText: {
            fn: () => this.insertText(),
            ico: 'blockquote'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['insertText']
        ],
        lang: this.$i18n.locale
      },
      isContractorNote: false,
      emptyOption: {
        value: null,
        label: this.$t('views.excmnote.form.empty')
      },
      senderTypeOptions: [],
      documentTemplateOptions: [],
      documentTemplate: null
    }
  },
  created () {
    this.fetchSenderTypeOptions()
    this.fetchDocumentTemplateOptions()
  },
  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async fetchSenderTypeOptions () {
      let baseParams = { pagination: false }
      const response = await new ApiService('sender_types', baseParams).getResults()
      this.senderTypeOptions = response.items.map(item => {
        return {
          value: item['@id'],
          text: item.title
        }
      })
      this.senderTypeOptions.unshift({ text: this.$t('global.notSet'), value: null })
    },
    async fetchDocumentTemplateOptions () {
      let baseParams = { pagination: false, templateType: 4 }
      const response = await new ApiService('document_templates', baseParams).getResults()
      this.documentTemplateOptions = response.items.map(item => {
        return {
          value: item['@id'],
          text: item.title,
          htmlContent: item.htmlContent
        }
      })
      this.documentTemplateOptions.unshift({ text: this.$t('global.notSet'), value: null })
    },
    onDocumentTemplateSelect (idDocumentTemplate) {
      let selectedDocumentTemplate = this.documentTemplateOptions.find(item => item.value === idDocumentTemplate)
      if (selectedDocumentTemplate && selectedDocumentTemplate.htmlContent) {
        this.item.subject = selectedDocumentTemplate.text
        this.item.contentEmail = selectedDocumentTemplate.htmlContent
      }
    }
  }
}
</script>
